<template src="./qr-not-found.html"></template>
<script>
import connectionHelper from '@/mixins/connection-helper.js';
export default {
  name: 'qr-not-found',
  mixins: [connectionHelper],
  computed: {},
  beforeDestroy() {
    this.destroyListener();
  },
  created() {
    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
  },
  destroyed() {},
  methods: {
    goTo(url) {
      this.$store.commit('setUrlVm', url);
      this.$router.push(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: auto;
  min-height: 100vh;
  background: #000 url('/static/img/laka-event/laka-user-not-found.png') no-repeat top center;
  background-size: 100% auto;
  position: relative;
}

.not-found-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  top: 490px;
  font-family: 'Pretendard';
}

.button-home {
  background: #5e0223;
  position: fixed;
  bottom: 52%;
  left: 50%;
  width: 45%;
  transform: translateX(-50%);
  color: white;
  padding: 15px 30px;
  border-radius: 48px;
  text-align: center;
  z-index: 1000;
  font-family: 'Pretendard';
  font-weight: 700;
  font-size: 40px;
  display: block;
  text-decoration: none;
}

.scan-footers {
  background-color: transparent !important;
  padding: 0 !important;
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
}

.logo {
  display: flex;
  align-items: center;
  margin-top: 60px;
  width: 276px;
  margin-bottom: 20px;
}

.svg-icon {
  width: 612px;
  margin-bottom: 20px;
}

h1 {
  font-size: 55px;
  font-weight: 700;
  margin-bottom: 15px;
}

p {
  margin-top: 30px;
  font-size: 30px;
  margin-bottom: 25px;
}

button {
  display: block;
  width: 100%;
  max-width: 600px;
  margin: 10px auto;
  padding: 30px 120px;
  font-size: 32px;
  border-radius: 48.91px;
  border: none;
  cursor: pointer;
  font-family: 'Pretendard';
  font-size: 32px;
  font-weight: 700;
  line-height: 38.4px;
  text-align: center;
}

.try-again {
  background-color: #231f20;
  color: white;
}

.cancel {
  background-color: #b32656;
  color: white;
}

.footer {
  position: absolute;
  bottom: -615px;
  background-color: #b32656;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120%;
}

.footer-info-logo {
  width: 40px;
  height: auto;
  margin-right: 15px;
}

.footer-text {
  font-family: 'Pretendard';
  font-size: 30px;
  font-weight: 400;
  line-height: 48px;
  text-align: left;
  color: #ffff;
  padding: 10px;
  border-radius: 5px;
}

@media screen and (max-width: 950px) and (min-width: 900px) {
  .not-found-text {
    top: 425px;
  }

  h1 {
    font-size: 52px;
  }

  p {
    margin-top: 30px;
    font-size: 28px;
  }
}
</style>
